import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { animeSchedule } from '../../services/images.service'

export function NewestPosts() {
  const posts = useSelector((state) => state.postModule.posts)

  const recentPosts = useMemo(() => {
    if (!Array.isArray(posts)) return []
    return posts
      .filter((post) => post?._id)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 6)
  }, [posts])

  if (!recentPosts.length) return null

  const postItems = recentPosts.map((post) => (
    <span key={post._id} className="mx-4">
      <Link to={`/post/${post._id}`} className="hover:underline text-white">
        {post.title}
      </Link>
    </span>
  ))
  // הוספת Red Dot כאלמנט מפריד בין כל כותרת
  const spacedPostItems = postItems.reduce((acc, item, idx) => {
    // דוחפים את האלמנט עצמו
    acc.push(item)
    // אם לא הפריט האחרון – מוסיפים red dot כאלמנט מפריד
    if (idx < postItems.length - 1) {
      acc.push(
        <img
          src={animeSchedule.redDot}
          key={`reddot-${idx}`}
          alt="Red Dot"
          className="mx-2"
        />
      )
    }
    return acc
  }, [])

  // כדי ליצור אפקט רציף, מכפילים את הרשימה
  const marqueeContent = <>{spacedPostItems}</>

  // הגדרת האנימציה – הזזת התוכן אופקית מ־0 לנקודה -1000px (התאם את הערך בהתאם לאורך התוכן)
  const marqueeVariants = {
    animate: {
      x: [0, -1000],
      transition: {
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 30,
          ease: 'linear',
        },
      },
    },
  }

  return (
    <div className="hidden p-4 overflow-hidden md:flex items-center">
      {/* טקסט קבוע */}
      <div className="hidden md:flex relative gap-2 font-noa bg-white px-4">
        <div className="absolute right-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="29"
            viewBox="0 0 18 29"
            fill="none"
          >
            <path
              d="M7.77872 12.7093C7.77872 12.7093 7.78454 12.7163 7.79036 12.7233C7.79036 12.7233 7.77872 12.7216 7.7729 12.7145C7.70306 12.6303 7.70306 12.6303 7.7729 12.7145L7.77872 12.7093Z"
              fill="#1B1B1B"
            />
            <path
              d="M34.7802 33.0604C34.4412 32.4535 34.1227 31.7672 33.8248 31.0125C32.1142 26.7547 31.0149 20.3677 31.0149 13.3719C31.0149 6.37616 32.1193 0.273914 33.8402 -3.45792C34.1279 -4.08526 34.4361 -4.65448 34.7546 -5.13966C27.3164 -9.01232 23.4277 -3.58538 16.4005 -1.9014C14.7002 -1.48833 12.1215 -1.27451 10.4212 -2.31339C13.2465 0.238088 16.118 1.9606 19.3953 2.39723C14.2584 1.89853 8.8647 5.49123 3.62508 3.51401C2.45901 3.06764 1.53951 2.48818 0.738159 1.54166C4.4778 6.45925 11.4845 13.3188 16.7549 14.4538C13.7396 15.1129 10.5958 14.5315 7.77568 12.5253C10.4623 16.5902 14.4536 17.7456 17.844 20.7732C14.6283 20.7915 12.1472 22.5435 10.8783 25.387C15.5221 19.3101 23.5202 35.6697 34.7751 33.0651L34.7802 33.0604Z"
              fill="#1B1B1B"
            />
            <path
              d="M33.8239 30.9939C33.3411 29.7943 32.9096 28.4254 32.5346 26.9156C31.5791 23.0638 31.0141 18.3246 31.0141 13.2712C31.0141 8.90892 31.4353 4.90225 32.1647 1.59378C32.6168 -0.44557 33.1818 -2.22486 33.8393 -3.66421C30.2281 -5.81507 23.6118 -4.24358 21.2848 -2.91953C19.939 -2.14638 18.7113 -1.13452 17.3962 -0.307029C19.8105 -0.246943 23.3704 3.22875 24.6598 5.83086C19.7078 1.2914 15.4237 6.43266 10.5847 5.90183C15.3466 8.67146 17.3551 14.9078 22.8053 17.1107C21.3054 18.1761 18.9219 17.7557 17.1394 17.0928C19.5845 19.1037 21.4287 21.2795 23.4166 23.6979C21.6239 23.5035 19.2763 23.5197 17.8791 22.715C22.2249 27.6509 28.949 31.8676 33.8239 30.9829L33.8239 30.9939Z"
              fill="#1B1B1B"
            />
          </svg>
        </div>
        <h5 className="text-black">עדכוני אנימה</h5>
        <span className="text-primary">
          {new Date().toLocaleString('he-IL', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          })}
        </span>
        <div className="absolute left-0 top-1/2 -translate-y-1/2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="10"
            viewBox="0 0 7 10"
            fill="none"
          >
            <path d="M7 5L-0.5 9.33013L-0.5 0.669872L7 5Z" fill="#353535" />
          </svg>
        </div>
      </div>
      {/* אזור לטקסט רץ */}
      <div className="flex-1 overflow-hidden">
        <motion.div
          className="flex items-center whitespace-nowrap"
          variants={marqueeVariants}
          animate="animate"
        >
          {marqueeContent}
        </motion.div>
      </div>
    </div>
  )
}

export default NewestPosts
